<template>

  <div class="ob-content">
    <ob-filters>
      <interventions-filters @change="$refs.table.refresh()" />
    </ob-filters>

    <v-card>
      <interventions-table
        ref="table"
        :source="source"
        @change="saveTable($event)"
        @click="$router.push({ name: 'issues/id', params: { id: $event.issue.id, interventionId: $event.id } })"
      />
    </v-card>
  </div>

</template>


<script>
import {mapMutations, mapState} from 'vuex'
import moment from 'moment'
import ApiService from '../../services/api.service.es6'
import InterventionsTable from './components/interventions-table'
import InterventionsFilters from './components/interventions-filters'
import ObFilters from '../shared/components/filters'


export default {
  data () {
    return {
      source: args => ApiService.findAllPaginated('interventions', this.apiFilters, args.sort, args.pagination)
    }
  },

  computed: {
    ...mapState('filters/interventions', [
      'filters',
      'table'
    ]),

    apiFilters () {
      return {
        dateFrom: moment(this.filters.interval.from),
        dateTo: moment(this.filters.interval.to).add(1, 'day'),
        type: this.filters.type,
        filter: [
          { name: 'assets.id', value: this.filters.assets },
          { name: 'assetTypes.id', value: this.filters.assetTypes },
          { name: 'users.id', value: this.filters.users }
        ]
      }
    }
  },

  methods: {
    ...mapMutations('filters/interventions', [
      'saveTable'
    ])
  },

  components: {
    ObFilters,
    InterventionsFilters,
    InterventionsTable
  }
}
</script>

<style scoped lang="scss">

</style>
